<template>
  <div style="width: 100%; height: 100%">
    <div class="banner">
      <div class="banner_center">
        <h1 id="appName">{{ appName }}</h1>
        <div class="login_box">
          <div class="login_box_left">
            <img src="@/assets/image/login2.png" alt=""/>
          </div>
          <div class="login_box_right">
            <div class="login">
              <div class="g-center login-page" @keyup.enter="doLogin">
                <el-form class="login-form">
                  <el-form-item>
                    <el-input :autofocus="true" required placeholder="请输入账号" id="loginName" v-model="username">
                      <template slot="prepend"><i class="el-icon-mobile-phone"></i></template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input placeholder="请输入密码" type="password" v-model="password">
                      <template slot="prepend"><i class="el-icon-info"></i></template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input placeholder="请输入验证码" v-model="captcha" style="width: 60%; text-align: left; vertical-align: top">
                      <template slot="prepend"><i class="el-icon-info"></i></template>
                    </el-input>
                    <div style="display: inline-block; width: 40%; height: 40px" @click="getCaptcha">
                      <el-image :src="captchaImg" alt="验证码" style="width: 140px; height: 40px;"></el-image>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button style="width: 25%" @click.native="regist" type="danger">注 册</el-button>
                    <el-button style="margin-left: 50px; width: 25%" @click.native="doLogin" type="primary" :loading="isBtnLoading">{{ btnText }}</el-button>
                    <el-button type="text" @click="forget">忘记密码</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div> <span>技术支持电话：88511155-6181</span></div>
            </div>
          </div>
          <div>
            <!-- 底部技术支持电话（固定在页面最下方） -->
<!--            <footer class="footer-contact">-->
<!--              <div class="contact-wrap">-->
<!--                <span class="contact-text">技术支持电话：</span>-->
<!--                <span class="contact-phone">88511155-6181</span>-->
<!--              </div>-->
<!--            </footer>-->
          </div>
        </div>
      </div>
    </div>
    <register ref="register" :projectList="projectList" :getMethod="getMethod"></register>
    <forget ref="forget"></forget>
  </div>
</template>

<script>
import {getCaptchaImg, login, getLoginInfo} from "@/api/api";
//登录
import * as util from "@/assets/js/util.js";
import register from "@/views/linXunRegister.vue";
import {checkPassWord} from "@/assets/js/validator";
import Forget from "@/views/forget";
import crypto from "crypto";
import {getTerm} from "@/api/system/linXuanChannel/linXuanChannel";

export default {
  components: {
    Forget,
    register,
  },
  data() {
    return {
      form: {
        user: {
          channelEntity: {
            id: null,
          },
        },
      },
      project: null,
      interTypeList: null,
      selectLoading: false,
      projectList: null,
      channelList: null, //渠道列表
      appName: null,
      username: "",
      password: "",
      captcha: "",
      captchaKey: "",
      captchaImg: "",
      businessType: "",
      isBtnLoading: false,
      identifyCode: "",
      versions: this.$store.state.versions,
      rules: {
        user: {
          loginName: [
            {message: "登录账号不能为空", trigger: "blur", required: true},
          ],
          loginPassword: [
            {validator: checkPassWord, required: true, trigger: "blur"},
          ]
        },
      },
      getMethod: "regist",
    };
  },
  computed: {
    btnText() {
      if (this.isBtnLoading) return "登录中...";
      return "登 录";
    },
  },
  created() {
    sessionStorage.clear();
    this.getCaptcha();
  },
  mounted() {
    this.appName = process.env.VUE_APP_NAME;
    // this.getCaptcha();
    // this.businessType="2"
    // this.getProjectListAll("2","","")
  },
  methods: {
    getCaptcha() {
      getCaptchaImg().then(res => {
        console.log(res.captchaKey)
        this.captchaKey = res.captchaKey;
        this.captchaImg = res.captchaImage;
      })
    },
    regist() {
        getTerm({
        }).then((res) => {
          if (res.code==200) {
            if(res.data!=null){
              if(res.data.isInRange==true){
                this.$refs.register.open();
              }else{
                this.$message.warning(res.data.info);
              }
            }
          } else {
            this.$message.error(res.message);
          }
        });
      //getProjectListAll({ businessType: "2", type: "regist" }).then((res) => {
      // if (res.code == 200) {
      //this.projectList = res.data;
      //this.$refs.register.open();
      // } else {
      //   this.$message.error(res.message);
      // }
      //});
    },
    forget() {
      this.$refs.forget.open();
    },
    doLogin() {
      const that = this;
      if (!that.username || !that.username.replace(/\s*/g, "")) {
        that.$message.error("请填写用户名！！！");
        that.username = "";
        return;
      }
      if (!that.password || !that.password.replace(/\s*/g, "")) {
        that.password = "";
        that.$message.error("请填写密码");
        return;
      }
      if (!that.captcha) {
        that.$message.error("请填写验证码");
        return;
      }
      if (!that.captchaKey) {
        that.$message.error("验证码错误");
        that.getCaptcha();
        return;
      }
      that.isBtnLoading = true;

      const cipher = crypto.createCipheriv('aes-128-cbc', Buffer.from('9@#hD*8637he%17U'),"RandomInitVector");
      // 登录密码进行加密
      let encrypted = cipher.update(that.password, 'utf8', 'base64');
      encrypted += cipher.final('base64');
      let param = {
        loginName: that.username,
        password: encrypted,
        captchaKey: that.captchaKey,
        captcha: that.captcha,
      };
      login(param).then((res) => {
        if (res.code === "200") {
          util.session("token", {token: res.data.token});
          that.$store.dispatch("setToken", res.data.token);
          util.session("expiration", {expiration: res.data.expiration});
          that.$store.dispatch("setExpiration", res.data.expiration);

          // 直接使用 login 接口返回的数据，无需再请求 loginInfo
          util.session("userInfo", {userInfo: res.data.user});
          that.$store.dispatch("setUserInfo", res.data.user);
          util.session("menuList", {menuList: res.data.menuList});
          that.$store.dispatch("setMenuList", res.data.menuList);
          util.session("userRole", {userRole: res.data.userRole});
          that.$store.dispatch("setUserRole", res.data.userRole);

          that.$emit("login", () => {
            that.$router.push({path: `/home`});
          });
        } else {
          that.getCaptcha();
          that.$message.error(res.data.error[0].errorMsg);
        }
        that.isBtnLoading = false;
      }).catch(() => {
        that.getCaptcha();
        that.isBtnLoading = false;
      })
    },

    queryLoginInfo() {
      const that = this;
      getLoginInfo({loginName: that.username}).then((res) => {
        if (res.code === "200") {
          util.session("userInfo", {userInfo: res.data.user});
          that.$store.dispatch("setUserInfo", res.data.user);
          console.log(res.data.user)
          util.session("menuList", {menuList: res.data.menuList});
          that.$store.dispatch("setMenuList", res.data.menuList);

          util.session("userRole", {userRole: res.data.userRole});
          that.$store.dispatch("setUserRole", res.data.userRole);
          that.$emit("login", () => {
            that.$router.push({path: `/home`});
          });
        } else {
          that.getCaptcha();
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style scoped>
#app {
  display: table;
  width: 100%;
}

.main-title {
  text-align: center;
}

.des {
  text-align: center;
  color: #999;
  margin-bottom: 2em;
}

.login-form {
  width: 400px;
  margin: 28% auto 0;
}

.login-page {
  background: #fff;
}

.banner {
  width: 100%;
  height: 100%;
  background: url(../assets/image/login1.png) repeat center;
  position: relative;
}

.banner_center {
  width: 1200px;
  height: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.banner_center h1 {
  font-size: 36px;
  color: #fff;
  font-weight: 700;
  text-align: center;
}

.banner_center .login_box {
  width: 80%;
  height: 95%;
  background-color: #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 30px;
}

.login_box_left {
  width: 50%;
  height: 100%;
  padding: 20px 30px;
  float: left;
  position: relative;
  border-right: 1px solid #eee;
  box-sizing: border-box;
}

.login_box_left img {
  display: block;
  width: 80%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login_box_right {
  width: 50%;
  height: 100%;
  float: left;
  position: relative;
  box-sizing: border-box;
}

.login_box_right .login {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  text-align: center;
}

.login input {
  width: 320px;
  height: 48px;
  background-color: #fff;
  margin-top: 20px;
  padding-left: 10px;
  font-size: 18px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.login a {
  display: block;
  width: 320px;
  height: 48px;
  line-height: 54px;
  background-color: #109eff;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  font-size: 20px;
  margin: 0 auto;
  margin-top: 30px;
}

.footer-contact {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  position: relative;
  bottom: 0;
  left: 0;
  z-index: 999;
}

.contact-wrap {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  color: #464545;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.contact-phone {
  color: #ffffff;
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
